<template>
  <div id="main">
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <!-- 查询表单 -->
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="5" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item :span="2">
            <a-form-item label="风险类型编码" label-col-flex="90px">
              <a-input v-model="queryForm.riskCode" placeholder="请输入风险类型编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>

          <a-grid-item :span="2">
            <a-form-item label="风险类型名称" label-col-flex="90px">
              <a-input v-model="queryForm.riskName" placeholder="请输入风险类型名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
<!--            <a-form-item label="分类级别" label-col-flex="60px">-->
<!--              <a-input v-model="queryForm.level" placeholder="请输入分类级别" class="input" allow-clear/>-->
<!--            </a-form-item>-->
            <!-- TODO 暂未使用@Enlin-03 -->
            <!--            <a-form-item label="分类级别" label-col-flex="60px">
                          <a-select v-model="queryForm.level" placeholder="请选择分类级别" @change="()=>{console.log(queryForm.level)}">
                            <a-option value="">全部</a-option>
                            <a-option value="category">分类</a-option>
                            <a-option value="priority">优先级</a-option>
                            <a-option value="status">状态</a-option>
                          </a-select>
                        </a-form-item>-->
          </a-grid-item>
          <a-grid-item :span="1" suffix="suffix">
            <a-row :gutter="12">
              <a-col flex="75px">
                <a-button type="primary" @click="handleQuery" :loading="loading">
                  <template #icon>
                    <icon-search style="stroke: #fff"/>
                  </template>
                  搜索
                </a-button>
              </a-col>
              <a-col flex="65px">
                <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              </a-col>
            </a-row>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>
    <a-space />
    <canvas-glass-card title="风险类型列表" variant="light" :hoverable="false" class="table-card">

      <!-- 数据表格 -->
      <div class="table-wrapper">
        <a-table
            row-key="id"
            :columns="columns"
            :data="pagination.records"
            :pagination="false"
            :loading="loading"
            column-resizable
            stripe
            :bordered="{cell:true}"
            hide-expand-button-on-empty
        >

          <template #level="{ record }">
            <span v-if="record.level === 1">一级分类</span>
            <span v-else-if="record.level === 2">二级分类</span>
            <span v-else>-</span>
          </template>

          <template #createTime="{ record }">
            {{ formatDate(record.createTime) }}
          </template>

          <template #updateTime="{ record }">
            {{ formatDate(record.updateTime) }}
          </template>
          
        </a-table>
      </div>

      <!-- 分页组件 -->
      <div class="pagination">
        <a-pagination
            style="justify-content: end;margin: 10px;"
            :total="pagination.total"
            v-model:current="pagination.current"
            v-model:page-size="pagination.size"
            show-total
            show-jumper
            show-page-size
            @change="handlePageChange"
            @page-size-change="handlePageSizeChange"
        />
      </div>
    </canvas-glass-card>
  </div>
</template>

<script>
import {getBaseDataRiskTypeList} from "@/apis/base-data-api";
import {Message} from "@arco-design/web-vue";
import CanvasGlassCard from "@/components/CanvasGlassCard.vue";
import {IconSearch} from "@arco-design/web-vue/es/icon";
import {getDictDataOfRiskTypeLevel} from "@/apis/system-data";
import {timestampNumber2dateString} from "@/utils/date-util";

export default {
  name: 'IssueLabel',
  components: {IconSearch, CanvasGlassCard},
  data() {
    return {
      // 条件查询表单数据
      queryForm: {
        // 风险类型编码
        riskCode: '',
        // 风险类型名称
        riskName: '',
        // 分类级别（1=一级分类，2=二级分类）
        level: '',
      },
      // 条件查询表单折叠
      collapsed: true,
      // 数据表格列配置
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   width: 80,
        //   fixed: 'left'
        // },
        {
          title: '排序序号',
          dataIndex: 'sortOrder',
          width: 120,
          sortable: {
            sortDirections: ['ascend', 'descend']
          },
        },
        // {
        //   //（一级分类为NULL，二级分类关联一级分类ID）
        //   title: '父级ID',
        //   dataIndex: 'parentId',
        //   width: 100
        // },
        {
          title: '风险类型编码',
          dataIndex: 'riskCode',
          width: 120,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '风险类型名称',
          dataIndex: 'riskName',
          width: 150,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '分类级别',
          dataIndex: 'level',
          slotName: 'level',
          width: 120,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '标签描述',
          dataIndex: 'riskDescription',
          ellipsis: true,
          tooltip: true,
          width: 200
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          slotName: 'createTime',
          width: 160,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          slotName: 'updateTime',
          width: 160,
          ellipsis: true,
          tooltip: true
        },
        // {
        //   title: '操作',
        //   slotName: 'actions',
        //   fixed: 'right',
        //   width: 180
        // }
      ],
      // 分页信息
      pagination: {
        records: [],
        current: 1,
        size: 10,
        pages: 0,
        total: 0
      },
      // 加载状态
      loading: false

    }
  },
  mounted() {
    this.fetchTableData();
    // TODO 暂未使用@Enlin-03 如果需要获取字典数据，请取消注释 
    // this.fetchRiskTypeLevelDictData();
  },
  methods: {
    // 获取表格数据
    fetchTableData() {
      this.loading = true;
      getBaseDataRiskTypeList({
        ...this.queryForm,
        current: this.pagination.current,
        size: this.pagination.size
      }).then(response => {
        // console.log(response)
        this.loading = false;
        if (response.code === 0) {
          this.pagination = response.data;
        } else {
          Message.error(response.message);
        }
      }).catch(error => {
        Message.error(error.message)
      })

    },
    // 获取 分类级别 字典数据
    fetchRiskTypeLevelDictData() {
      getDictDataOfRiskTypeLevel()
          .then(response => {
            if (response.code === 0) {
            } else {
              Message.error(response.message);
            }
          })
          .catch(error => {
            Message.error(error);
          })
    },
    // 处理查询
    handleQuery() {
      this.pagination.current = 1;
      this.fetchTableData();
    },

    // 处理重置
    handleReset() {
      this.queryForm = {
        riskCode: '',
        riskName: '',
        level: '',
        tagStatus: '',
        // createTimeRange: []
      };
      this.handleQuery();
    },

    // 处理页码变化
    handlePageChange(page) {
      console.log(page)
      this.fetchTableData();
    },

    // 处理每页数量变化
    handlePageSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.fetchTableData();
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '—';
      // return dateString.substring(0, 16).replace('T', ' ');
      return timestampNumber2dateString(dateString)
    },

    // 处理状态切换
    // handleToggleStatus(record) {
    //   this.$message.success(`已${record.tagStatus === 1 ? '禁用' : '启用'}标签：${record.riskName}`);
    // },

    // 处理删除
    // handleDelete(record) {
    //   this.$message.success(`已删除标签：${record.riskName}`);
    // },
  },
}
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}
</style>